/* ==========================================================================
   予約注文ボタンの見た目を維持する（Timesact × Globo Product Options）
   2026-08-02 claude / ルミエール独自

   【症状】
     予約注文商品で Globo Product Options のオプション（配送方法など）を
     選ぶと、青い「予約注文」ボタンが通常の「カートに追加する」に戻る。

   【原因】※ブラウザで実測して確認済み
     ボタン要素は作り直されていない（同じ要素のまま）。
     GPOが管理しているボタン（class に gpo-clone-atc-button が付く）で、
     オプション変更のたびに GPO が class と文字をテーマの初期状態へ
     書き戻すため、Timesact が付けた timesact-button クラスと
     ボタン文字・インラインstyle（青色）が失われる。

   【対処】
     Timesact が「予約注文」を適用した時点の見た目を記憶しておき、
     GPO に書き戻されたら、そのまま戻す。
     Timesact の再初期化は呼ばない（競合しないため安定する）。

   【暴走しないための制限】
     ・timesact-button が一度も付いていない商品では何もしない
     ・バリエーションが変わったら記憶を破棄する
       （切り替え先が予約注文でない可能性があるため）
     ・フォームを操作した直後の数秒だけ復元する
   ========================================================================== */
(function () {
  'use strict';

  var TA_CLASS = 'timesact-button';
  var ACTIVE_MS = 4000;

  var snapshot = null; // { html, cls, style, variant }
  var activeUntil = 0;
  var targetButton = null; // timesact-button が付いた「その要素」を保持する

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  /*
    ★ GPOはカートボタンを複製する（class に gpo-clone-atc-button が付く）。
      そのためページ内に候補が複数あり、セレクタで最初の1つを取ると
      非表示側を掴んでしまうことがある。
      timesact-button が実際に付いている要素を探して、その参照を保持する。
  */
  function findTimesactButton() {
    var form = productForm();
    if (!form) return null;

    var candidates = form.querySelectorAll('button, input[type=submit]');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].classList.contains(TA_CLASS)) return candidates[i];
    }
    return null;
  }

  function currentVariant() {
    var form = productForm();
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function capture(button) {
    snapshot = {
      html: button.innerHTML,
      cls: button.className,
      style: button.getAttribute('style') || '',
      variant: currentVariant(),
    };
  }

  function restore(button) {
    button.className = snapshot.cls;
    button.innerHTML = snapshot.html;
    if (snapshot.style) {
      button.setAttribute('style', snapshot.style);
    } else {
      button.removeAttribute('style');
    }
  }

  function handleChange() {
    // Timesactが適用されている状態なら、その要素と見た目を記憶して終わり
    var applied = findTimesactButton();
    if (applied) {
      targetButton = applied;
      capture(applied);
      return;
    }

    if (!snapshot || !targetButton) return;      // 予約注文商品ではない
    if (!targetButton.isConnected) return;       // 要素が無くなっている
    if (Date.now() > activeUntil) return;        // 操作直後以外は触らない
    if (currentVariant() !== snapshot.variant) { // バリエーションが変わった
      snapshot = null;
      targetButton = null;
      return;
    }

    restore(targetButton);
  }

  // 動作確認用（Console から window.__preorderKeep で状態を見られる）
  window.__preorderKeep = function () {
    return {
      記憶あり: !!snapshot,
      対象ボタン: targetButton ? targetButton.innerText.trim() : 'なし',
      対象のclass: targetButton ? targetButton.className : 'なし',
      候補ボタン数: productForm()
        ? productForm().querySelectorAll('button, input[type=submit]').length
        : 0,
      操作直後か: Date.now() <= activeUntil,
    };
  };

  function markActive() {
    activeUntil = Date.now() + ACTIVE_MS;
  }

  function start() {
    // 複製ボタンがフォームのどこに置かれても拾えるよう、フォーム全体を監視する
    var target = productForm();
    if (!target || !('MutationObserver' in window)) return;

    // フォーム内の操作（GPOのオプション選択を含む）を拾う
    document.addEventListener('change', markActive, true);
    document.addEventListener('click', function (event) {
      var el = event.target;
      if (el && typeof el.closest === 'function' && el.closest('form[action*="/cart/add"]')) {
        markActive();
      }
    }, true);

    new MutationObserver(handleChange).observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    // Timesactの初期適用を記憶する
    setTimeout(handleChange, 1500);
    setTimeout(handleChange, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
